import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from '@material-ui/core';

import { ConfidenceWebsiteLink } from '@spotify/confidence-core-react';

import { useCreateAccountFormContext } from './CreateAccountFormProvider';

export const CreateWorkspaceFooter = () => {
  const {
    canSubmit,
    acceptMarketingEmails,
    setAcceptMarketingEmails,
    handleCreate,
  } = useCreateAccountFormContext();

  return (
    <>
      <Typography variant="body2" color="textSecondary">
        By clicking "Create workspace", you confirm that you have read and agree
        to the{' '}
        <ConfidenceWebsiteLink underline="always" route="/terms-of-service">
          Terms of Service
        </ConfidenceWebsiteLink>
        .
      </Typography>
      <Box marginTop={2}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          fullWidth
          disabled={!canSubmit}
          onClick={handleCreate}
        >
          Create workspace
        </Button>
      </Box>
      <Box marginTop={2}>
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              color="default"
              checked={acceptMarketingEmails}
              onChange={(_e, checked) => setAcceptMarketingEmails(checked)}
              name="marketing-emails"
            />
          }
          label={
            <Typography variant="body2" color="textSecondary">
              Send me tips and updates to help me get started with Confidence
            </Typography>
          }
        />
      </Box>
    </>
  );
};
